import { useMediaQuery } from 'usehooks-ts'

export function useBreakpoint() {
  const isMd = useMediaQuery('(min-width: 750px)')
  const isLg = useMediaQuery('(min-width: 1024px)')
  return { isMobile: !isMd, isTablet: isMd && !isLg, isDesktop: isLg }
}
